import * as z from 'zod';
import { schema } from '@forms/helpers';
import { NoteFormSchemaProps, NoteFormValues } from './types';

export const formSchema = ({ usage, id }: NoteFormSchemaProps) =>
  z.object({
    content: schema.input({ name: usage === 'office' ? 'comment' : 'note', required: !id }),
    important: schema.boolean(),
  });

export const defaultValues: NoteFormValues = {
  content: '',
  important: false,
};
